<template>
	<lcsj-dialog v-model="showDialog" title="个人信息" width="800px" custom-class="profile-edit-dialog" @close="closeDialog" cancel-text="取消" confirm-text="保存" :confirm-loading="saveloading" @confirm="submitForm('editForm')">
			<div class="user-info-panel">
			<p class="profile-edit-hint">可更新照片、签名和联系方式，其余信息由管理员维护。</p>
			<el-form ref="editForm" label-position="top" :model="editForm" :rules="rules" class="profile-edit-form">
				<el-form-item label="姓名" prop="chName">
					<el-input v-model="editForm.chName" disabled class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="用户名" prop="userName">
					<el-input v-model="editForm.userName" disabled class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="照片" prop="userImagePath" class="profile-media">
					<el-upload
						v-if="showImg.photo === ''"
						ref="upload"
						class="input_200px"
						:headers="headers"
						:data="editPhoto"
						:multiple="false"
						:action="action2"
						:on-success="progress"
						:limit="1"
						list-type="picture-card"
						:auto-upload="true"
						:show-file-list="false"
					>
						<template #default>
							<i class="el-icon-camera"></i><span class="profile-upload-label">上传照片</span>
						</template>
					</el-upload>
					<div v-else class="input_200px">
						<div class="up_img">
							<img :src="showImg.photo" alt="个人照片" />
							<button type="button" class="ui_delete" aria-label="更换照片" @click="deleteImg(1)"><i class="el-icon-edit"></i></button>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="签名" prop="signImg" class="profile-media profile-media--signature">
					<el-upload
						v-if="showImg.sign === ''"
						ref="upload"
						class="input_200px"
						:headers="headers"
						:data="editPhoto"
						:multiple="false"
						:action="action1"
						:on-success="progress"
						:limit="1"
						list-type="picture-card"
						:auto-upload="true"
						:show-file-list="false"
					>
						<template #default>
							<i class="el-icon-edit"></i><span class="profile-upload-label">上传签名</span>
						</template>
					</el-upload>
					<div v-else class="input_200px">
						<div class="up_img">
							<img :src="showImg.sign" alt="个人签名" />
							<button type="button" class="ui_delete" aria-label="更换签名" @click="deleteImg(2)"><i class="el-icon-edit"></i></button>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="性别" prop="gender">
					<el-radio-group v-model="editForm.gender" disabled class="input_200px">
						<el-radio-button :label="1">男</el-radio-button>
						<el-radio-button :label="0">女</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="工号" prop="workerNo">
					<el-input v-model="editForm.workerNo" disabled class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="卡号" prop="cardNo">
					<el-input v-model="editForm.cardNo" disabled class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="身份证号" prop="idCardNo">
					<el-input v-model="editForm.idCardNo" disabled class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="部门" prop="deptCode">
					<el-input v-model="editForm.dept" disabled class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="角色" prop="roleId">
					<el-input v-model="editForm.roleName" disabled class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="人员职级" prop="userRank">
					<el-input v-model="editForm.userRank" disabled class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="人员类别" prop="userType">
					<el-select v-model="editForm.userType" disabled size="small" filterable :clearable="true" class="input_200px">
						<el-option v-for="item in userTypeList" :key="item.dicCode" :label="item.dicText" :value="item.dicCode"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="联系方式" prop="phone">
					<el-input clearable v-model="editForm.phone" class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="comment" class="profile-wide">
					<el-input v-model="editForm.comment" disabled :autosize="{ minRows: 2 }" class="input_200px" type="textarea"></el-input>
				</el-form-item>
			</el-form>
		</div>

	</lcsj-dialog>
</template>
<script>
import { GetUserInfoDetail, UpdateUserPhone } from "../../../api/userApi.js";
import { GetDicDataListByParentCode } from "../../../api/dicDataApi.js";
export default {
	props: [],
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			showDialog: false,
			saveloading: false,
			editForm: {},
			rules: {},
			userTypeList: [],
			hideUpload: false,
			limitCount: 1,
			headers: {
				Authorization: "Bearer " + localStorage.getItem("logintoken")
			},
			action1: "/api/sysConfig/User/UpdateUserSignature",
			action2: "/api/sysConfig/User/UpdateUserPhoto",
			// 签名、人员照片
			editPhoto: {
				KeyId: ""
			},

			showImg: {
				photo: "",
				sign: ""
			}
		};
	},
	computed: {},
	watch: {},
	components: {},
	created() {},
	methods: {
		// 显示
		showUserInfoDialog(data) {
			this.showDialog = true;
			this.editPhoto.KeyId = data.keyId;
			this.getUserType();
			this.getUserInfoDetail();
		},

		// 点击保存
		submitForm() {
			if (this.saveloading) return;
			this.$refs.editForm.validate((valid) => {
				if (valid) {
					this.updateUserPhone();
				} else {
					return false;
				}
			});
		},

		// 删除图片
		deleteImg(type) {
			if (type === 1) {
				this.showImg.photo = "";
			} else {
				this.showImg.sign = "";
			}
		},

		// 获取个人信息详情
		getUserInfoDetail() {
			let parameter = {
				keyId: this.editPhoto.KeyId
			};
			GetUserInfoDetail(parameter)
				.then((res) => {
					if (res.code == 1) {
						this.editForm = res.data;
						if (res.data.photoImg === "") {
							this.showImg.photo = "";
						} else {
							this.showImg.photo = "data:image/png;base64," + res.data.photoImg;
						}
						if (res.data.signImg === "") {
							this.showImg.sign = "";
						} else {
							this.showImg.sign = "data:image/png;base64," + res.data.signImg;
						}
						this.showDialog = true;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("加载失败，请稍后再试！");
				});
		},

		// 获取人员类型
		getUserType() {
			let parmter = {
				parentCode: "UserType"
			};
			GetDicDataListByParentCode(parmter)
				.then((res) => {
					if (res.code == 1) {
						this.userTypeList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("加载失败，请稍后再试！");
				});
		},

		// 更新电话号码
		updateUserPhone() {
			this.saveloading = true;
			let param = {
				keyId: this.editForm.keyId,
				phone: this.editForm.phone
			};
			UpdateUserPhone(param)
				.then((res) => {
					this.saveloading = false;
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: "保存成功！"
						});
						this.showDialog = false;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.saveloading = false;
					this.$message.error("保存失败，请稍后再试！");
				});
		},

		progress(event, file) {
			this.getUserInfoDetail();
		},

		// 关闭
		closeDialog() {
			this.showDialog = false;
		}
	}
};
</script>
<style scoped lang="scss">
.user-info-panel { padding: 2px 6px 6px; }
.profile-edit-hint { margin: 0 0 18px; padding: 10px 14px; border-radius: 8px; background: var(--app-primary-soft); color: var(--app-primary-text); font-size: 13px; line-height: 1.6; }
.profile-edit-form { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px 24px; }
.profile-edit-form ::v-deep .el-form-item { min-width: 0; width: auto; margin: 0; }
.profile-edit-form ::v-deep .el-form-item__label { float: none; display: block; width: auto; padding: 0 0 7px; line-height: 20px; color: var(--app-text-secondary); }
.profile-edit-form ::v-deep .el-form-item__content { display: block; min-width: 0; width: 100%; margin-left: 0 !important; line-height: 32px; }
.profile-edit-form ::v-deep .input_200px { width: 100% !important; max-width: 100%; }
.profile-edit-form ::v-deep .el-input__inner { height: 36px; line-height: 36px; }
.profile-edit-form ::v-deep .el-input.is-disabled .el-input__inner,
.profile-edit-form ::v-deep .el-textarea.is-disabled .el-textarea__inner { background: var(--app-surface-muted); color: var(--app-text-secondary); border-color: var(--app-border); }
.profile-edit-form ::v-deep .el-radio-button__inner { padding: 10px 24px; }
.profile-edit-form ::v-deep .el-radio-button__orig-radio:disabled:checked + .el-radio-button__inner { opacity: 1; }
.profile-wide { grid-column: 1 / -1; }
.profile-media { order: -1; padding: 14px 16px; border: 1px solid var(--app-border); border-radius: 10px; background: var(--app-surface-muted); }
.profile-media ::v-deep .el-form-item__content { display: flex; justify-content: center; }
.profile-media ::v-deep .el-upload { display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 8px; width: 100%; height: 88px; line-height: 1; background: var(--app-surface); border-color: var(--app-border-strong); border-radius: 8px; color: var(--app-text-secondary); }
.profile-media ::v-deep .el-upload:hover { border-color: var(--app-primary); color: var(--app-primary-text); background: var(--app-primary-soft); }
.profile-media ::v-deep .el-upload i { color: inherit; font-size: 25px; }
.profile-upload-label { font-size: 12px; }
.up_img { position: relative; width: 88px; height: 88px; margin: 0 auto; }
.up_img img { width: 100%; height: 100%; object-fit: cover; border-radius: 50%; border: 1px solid var(--app-border); box-sizing: border-box; }
.profile-media--signature .up_img { width: 100%; }
.profile-media--signature .up_img img { object-fit: contain; border-radius: 8px; background: var(--app-surface); }
.ui_delete { position: absolute; right: -4px; bottom: 0; display: grid; place-items: center; width: 28px; height: 28px; border: 1px solid var(--app-border); border-radius: 50%; background: var(--app-surface); color: var(--app-primary-text); cursor: pointer; }
.ui_delete:hover { background: var(--app-primary-soft); border-color: var(--app-primary); }
.ui_delete:focus-visible { outline: 2px solid var(--app-primary); outline-offset: 2px; }
@media (max-width: 600px) { .profile-edit-form { grid-template-columns: minmax(0, 1fr); gap: 16px; } .user-info-panel { padding: 0; } }
</style>
<style>
.profile-edit-dialog .el-dialog { max-width: calc(100vw - 32px); }
</style>
